// extracted by mini-css-extract-plugin
module.exports = {"component":"FilterSlider_component__9uAIP","label":"FilterSlider_label__Pd2YK"};